export default __webpack_public_path__ + "static/media/genuine.c29014f0.jpeg";